// John Eldhose 20180521
import { RestfulPost } from './Restful';

export async function recover(email) {
  let data = {
    email: email
  };
  const Recover = await RestfulPost('recover', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return Recover;
}



// WEBPACK FOOTER //
// ./src/Api/recover.js